// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3pVON","signatureBlock":"Footer_signatureBlock__29O8U","signature":"Footer_signature__Zr9tI"};